import { Link } from "react-router-dom";

const explore = [
  { label: "Career Hubs", to: "/roadmaps" },
  { label: "Free Finance Interview Guide", href: "https://payhip.com/b/Eyemc" },
  { label: "Finance Career AI", to: "/career-ai" },
  { label: "Ebooks", to: "/ebooks" },
  { label: "Premium Playbooks", to: "/playbooks" },
];

const careers = [
  { label: "Investment Banking", to: "/roadmaps/investment-banking" },
  { label: "Private Equity", to: "/roadmaps/private-equity" },
  { label: "Energy Finance", to: "/roadmaps/energy" },
  { label: "Venture Capital", to: "/roadmaps/venture-capital" },
  { label: "Hedge Funds", to: "/roadmaps/hedge-funds" },
  { label: "Real Estate Finance", to: "/roadmaps/real-estate" },
];

const info = [
  { label: "About VantStride", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Copyright & Intellectual Property", to: "/copyright-and-intellectual-property" },
  { label: "Refund Policy", to: "/refund-policy" },
  { label: "Affiliate Disclosure", to: "/affiliate-disclosure" },
];

const columns = [
  { title: "Explore", items: explore },
  { title: "Careers", items: careers },
  { title: "Information", items: info },
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-6">
        <div className="md:col-span-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-xl bg-[#0A2540] text-white grid place-items-center">
              <img
                src="/vs-monogram.png"
                alt=""
                aria-hidden="true"
                className="w-5 h-5 object-contain"
              />
            </div>
            <span className="font-display text-lg font-semibold text-[#0A2540]">
              VantStride
            </span>
          </div>
          <p className="mt-4 text-sm text-slate-600 max-w-md leading-relaxed">
            Helping ambitious students prepare for finance careers through Career Hubs, premium playbooks, ebooks, curated recommendations, and finance-focused AI.
          </p>
        </div>

        {columns.map((col) => (
          <div key={col.title}>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-3">
              {col.title}
            </div>
            <ul className="space-y-2 text-sm text-slate-600">
              {col.items.map((it) => (
                <li key={it.to || it.href}>
                  {it.href ? (
                    <a
                      href={it.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`footer-link-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="hover:text-[#0A2540] transition-colors"
                    >
                      {it.label}
                    </a>
                  ) : (
                    <Link
                      to={it.to}
                      data-testid={`footer-link-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="hover:text-[#0A2540] transition-colors"
                    >
                      {it.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-100 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} VantStride. All rights reserved.
      </div>
    </footer>
  );
}
